import state_config from './config'
import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export default{
  [state_config.LOGIN]: function(state) {
    state.loading = true
  },
  [state_config.LOGIN_SUCCESS]: function(state) {
    state.isLoggedIn = true
    state.loading = false
  },
  [state_config.LOGIN_FAIL]: function(state) {
    state.loading = false
  },
  [state_config.LOGOUT]: function(state) {
    state.isLoggedIn = false
    state.loading = false
  },
  [state_config.SELECT_BOT]: function(state) {
    state.isSelectedBot = true
  },
  [state_config.LOADING]: function(state) {
    state.loading = !state.loading 
  },
  [state_config.CLEAR_LOADING]: function (state) {
    state.loading = false
  },
  [state_config.SIDEBAR]: function(state) {
    state.openSidebar = !state.openSidebar 
  },
  [state_config.SELECT_NEW_BOT]: function(state,bot) {
    state.selectedBot = bot
  },
  [state_config.UPDATE_SETTING]: function (state, setting) {
    state.setting = setting
  },
  [state_config.UPDATE_WELCOME_MESSAGE]: function(state, welcomeMessage) {
    state.welcomeMessage = welcomeMessage
  },
  [state_config.UPDATE_MODAL_WELCOME]: function (state, value) {
    if (value) {
      state.showModalWelcome = true
      Vue.localStorage.set('showModalWelcome', true)
    } else {
      state.showModalWelcome = undefined
      Vue.localStorage.remove('showModalWelcome')
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js